import React from 'react'

const RegistrationUserInputField = ({formLabel, userGivenData, className, requiredStar}) => {
  return (
    <>
        <p className={`${className}`}>{formLabel} <span className='redStar'>{requiredStar}</span></p>
    </>
  )
}

export default RegistrationUserInputField